import { Star } from 'lucide-react'
import type { RatingResponse } from '../../types/api'

export function Stars({ rating, size = 13 }: { rating: number; size?: number }) {
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${rating} out of 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= Math.round(rating) ? 'fill-sun-500 text-sun-500' : 'text-ink-200'}
        />
      ))}
    </span>
  )
}

export function RecentRatings({ ratings }: { ratings: RatingResponse[] }) {
  if (ratings.length === 0) return null

  return (
    <div>
      <h2 className="text-lg font-bold text-ink-900">Recent ratings</h2>
      <div className="mt-3 space-y-3">
        {ratings.slice(0, 5).map((r) => (
          <div key={r.id} className="card-pad">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="flex items-center gap-2">
                <Stars rating={r.rating} />
                <span className="text-sm font-semibold text-ink-900">{r.rating.toFixed(1)}</span>
              </span>
              <span className="text-xs text-ink-400">
                {new Date(r.createdAt).toLocaleDateString()}
              </span>
            </div>
            {r.comments && <p className="mt-1.5 text-sm text-ink-600">{r.comments}</p>}
          </div>
        ))}
      </div>
    </div>
  )
}
